export const POST_PRESENTATIONS = [
  "widget_small",
  "widget_large",
  "dialog",
] as const;
export type PostPresentation = (typeof POST_PRESENTATIONS)[number];

export function isPostPresentation(value: unknown): value is PostPresentation {
  return POST_PRESENTATIONS.some((item) => item === value);
}

// 更新前の埋め込みスクリプトとの通信境界でだけ旧サイズへ変換する。
export function legacyPostSize(
  presentation: PostPresentation,
): "small" | "large" {
  return presentation === "widget_small" ? "small" : "large";
}
